(ns admin.components.composite.learning-objective-pill
  (:require
   [kyber.components.base.text :as text]
   [kyber.styles.core :refer [gs styles->classes]]))

(def classes
  (styles->classes
   {:pill
    {:display :inline-block
     :overflow :hidden
     :padding [[(gs [:spacing :p0])
                (gs [:spacing :p12])
                (gs [:spacing :p0])
                (gs [:spacing :p12])]]
     :border-radius (gs [:radius :r40])}}))

(defn render
  [{:keys [max-width label]
    :or {max-width 300}}]
  (let [label* (or label "No Learning Objective Set")]
    [:div {:class (:pill classes)
           :style {:max-width (str max-width "px")
                   :background-color (if (some? label)
                                       (gs [:colors :warning-500])
                                       (gs [:colors :gray-scale-400]))}}
     [text/caption-10 :p
      {:style {:color (gs [:colors :true-white])
               :font-weight (gs [:font-weight :title-10])
               :white-space :nowrap
               :overflow :hidden
               :text-overflow :ellipsis}
       :title label*}
      label*]]))
